$.extend($.validator.messages, {
    required: error_messages.required,
    email: error_messages.email
});

$('.js-business-hero-btn').removeAttr('disabled')